module.exports = __webpack_public_path__ + "static/media/doctors.be3cbad2.png";